<p-menu
  class="m-menu"
  #menu
  [model]="menuItems"
  [popup]="true"
  [style]="style"
  [styleClass]="styleClass + ' ' + menuStyle"
  [appendTo]="appendTo"
  [autoZIndex]="autoZIndex"
  [baseZIndex]="baseZIndex"
  [showTransitionOptions]="showTransitionOptions"
  [id]="id"
  (onShow)="onMenuOpen()"
  (onHide)="onMenuClose()"></p-menu>
<m-button
  [type]="menuStyle === 'menu-default' ? 'secondary' : 'menu'"
  [styleClass]="isMenuOpen ? 'active has-icon' : 'has-icon'"
  [badge]="buttonBadge"
  [disabled]="disabled"
  [style]="style"
  [ariaLabel]="ariaLabel"
  (click)="menu.toggle($event)">
  <div
    [class]="
      (iconPlacement === 'left' ? 'flex' : 'flex flex-row-reverse') +
      ' items-center gap-1'
    ">
    @if (showArrow) {
      <span aria-hidden="true" class="material-symbols-outlined icon-small">
        {{ isMenuOpen ? "keyboard_arrow_up" : "keyboard_arrow_down" }}
      </span>
    }
    <ng-content></ng-content>
  </div>
</m-button>
